import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box, Text, Flex, FormControl, FormLabel, Input,
  Button, Alert, AlertIcon, Spinner,
} from '@chakra-ui/react';
import { FaDiscord, FaYoutube, FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa';
import * as FiIcons from 'react-icons/fi';
import { getSettings, updateSettings } from '../../../../store/settings/settingsSlice';
import theme from '../../../global/theme';

const FIELDS = [
  { name: 'discord',   label: 'رابط Discord',   icon: <FaDiscord  color="#5865f2" />, placeholder: 'https://discord.gg/...' },
  { name: 'discordGuildId', label: 'معرّف سيرفر Discord (Server ID)', icon: <FaDiscord color="#5865f2" />, placeholder: 'مثال: 123456789012345678' },
  { name: 'youtube',   label: 'رابط YouTube',   icon: <FaYoutube  color="#ff0000" />, placeholder: 'https://youtube.com/...' },
  { name: 'whatsapp',  label: 'رابط WhatsApp',  icon: <FaWhatsapp color="#25d366" />, placeholder: 'https://wa.me/...' },
  { name: 'facebook',  label: 'رابط Facebook',  icon: <FaFacebook color="#1877f2" />, placeholder: 'https://facebook.com/...' },
  { name: 'instagram', label: 'رابط Instagram', icon: <FaInstagram color="#e1306c" />, placeholder: 'https://instagram.com/...' },
  { name: 'commission', label: 'العمولة على إعلانات المتجر (دولار)', icon: <FiIcons.FiDollarSign color="#22c55e" />, placeholder: '5', type: 'number' },
  { name: 'binance_id', label: 'معرّف Binance لاستقبال المدفوعات', icon: <FiIcons.FiCreditCard color="#f0b90b" />, placeholder: 'Binance ID / Pay ID' },
];

const Settings = () => {
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settings);

  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings.data) {
      reset({
        discord:        settings.data.discord        ?? '',
        discordGuildId: settings.data.discordGuildId ?? '',
        youtube:   settings.data.youtube   ?? '',
        whatsapp:  settings.data.whatsapp  ?? '',
        facebook:  settings.data.facebook  ?? '',
        instagram: settings.data.instagram ?? '',
        commission: settings.data.commission ?? 0,
        binance_id: settings.data.binance_id ?? '',
      });
    }
  }, [settings.data, reset]);

  const onSubmit = (values) => {
    dispatch(updateSettings(values));
  };

  return (
    <Box>
      <Box mb={6}>
        <Text fontSize={{ base: '24px', md: '28px' }} fontWeight="800" color={theme.dark} mb={1}>
          إعدادات المجتمع
        </Text>
        <Text color={theme.text} fontSize="14px">
          تحديث روابط حسابات التواصل الاجتماعي للمجتمع
        </Text>
      </Box>

      <Box
        bg={theme.light}
        border={`1px solid ${theme.border}`}
        borderRadius="24px"
        boxShadow={theme.shadow}
        p={{ base: 4, md: 6 }}
        maxW="640px"
      >
        {settings.isLoading && !settings.data ? (
          <Flex align="center" justify="center" minH="200px" direction="column" gap={3}>
            <Spinner color={theme.primary} thickness="4px" size="xl" />
            <Text color={theme.text} fontWeight="600">جاري التحميل...</Text>
          </Flex>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            {settings.errors.length > 0 && (
              <Alert status="error" variant="left-accent" mb={5} borderRadius={8}>
                <AlertIcon />
                {settings.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
              </Alert>
            )}

            {FIELDS.map(({ name, label, icon, placeholder, type }) => (
              <FormControl key={name} mb={5}>
                <FormLabel color={theme.dark} fontWeight="600" fontSize="14px">
                  <Flex align="center" gap={2}>
                    {icon} {label}
                  </Flex>
                </FormLabel>
                <Input
                  type={type || 'text'}
                  bg={theme.bg}
                  border={`1px solid ${theme.border}`}
                  borderRadius={8}
                  color={theme.dark}
                  placeholder={placeholder}
                  _placeholder={{ color: theme.text }}
                  _focus={{ borderColor: theme.primary, boxShadow: 'none' }}
                  dir="ltr"
                  {...register(name)}
                />
              </FormControl>
            ))}

            <Flex justify="flex-end" mt={2}>
              <Button
                type="submit"
                colorScheme="teal"
                bg={theme.primary}
                rightIcon={<FiIcons.FiSave />}
                isLoading={settings.isLoading}
                loadingText="جاري الحفظ..."
                borderRadius={8}
                px={8}
              >
                حفظ الإعدادات
              </Button>
            </Flex>
          </form>
        )}
      </Box>
    </Box>
  );
};

export default Settings;
